import React from "react";
import './../styles/SingularCriterion.css';
function SingularCriterion(props) {
    let onChangeFunc = function (event) {
        const target = event.target;
        props.stateToChangeChosenFeatures(chosenFeatures => {
            return Object.assign({}, props.setFeature(chosenFeatures, target.value));
        });
    };
    return React.createElement("select", { onChange: onChangeFunc, className: 'SingularCriterion', defaultValue: '' },
        React.createElement("option", { value: '' }, 'Any ' + props.criterionName),
        props.features.map((feature, index) => {
            return React.createElement("option", { key: index, value: feature }, feature);
        }));
}
export default SingularCriterion;
